// ============================================
// MODERN IMAGE LIGHTBOX
// Fast, lightweight, no dependencies
// ============================================

class Lightbox {
    constructor() {
        this.currentIndex = 0;
        this.images = [];
        this.isOpen = false;
        this.init();
    }

    init() {
        // Create lightbox HTML
        const lightboxHTML = `
      <div class="lightbox" id="lightbox" role="dialog" aria-modal="true" aria-label="Image lightbox">
        <button class="lightbox-close" aria-label="Close lightbox"></button>
        <button class="lightbox-nav lightbox-prev" aria-label="Previous image"></button>
        <button class="lightbox-nav lightbox-next" aria-label="Next image"></button>
        <div class="lightbox-content">
          <img class="lightbox-image" src="" alt="">
        </div>
        <div class="lightbox-counter"></div>
      </div>
    `;

        document.body.insertAdjacentHTML('beforeend', lightboxHTML);

        this.lightbox = document.getElementById('lightbox');
        this.lightboxImage = this.lightbox.querySelector('.lightbox-image');
        this.closeBtn = this.lightbox.querySelector('.lightbox-close');
        this.prevBtn = this.lightbox.querySelector('.lightbox-prev');
        this.nextBtn = this.lightbox.querySelector('.lightbox-next');
        this.counter = this.lightbox.querySelector('.lightbox-counter');

        this.bindEvents();
    }

    bindEvents() {
        // Close button
        this.closeBtn.addEventListener('click', () => this.close());

        // Navigation buttons
        this.prevBtn.addEventListener('click', () => this.prev());
        this.nextBtn.addEventListener('click', () => this.next());

        // Click outside to close
        this.lightbox.addEventListener('click', (e) => {
            if (e.target === this.lightbox) {
                this.close();
            }
        });

        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
            if (!this.isOpen) return;

            switch (e.key) {
                case 'Escape':
                    this.close();
                    break;
                case 'ArrowLeft':
                    this.prev();
                    break;
                case 'ArrowRight':
                    this.next();
                    break;
            }
        });
    }

    open(images, index = 0) {
        this.images = images;
        this.currentIndex = index;
        this.isOpen = true;

        // Prevent body scroll
        document.body.style.overflow = 'hidden';

        // Show lightbox
        this.lightbox.classList.add('active');
        this.updateImage();

        // Focus management
        this.closeBtn.focus();
    }

    close() {
        this.isOpen = false;
        this.lightbox.classList.remove('active');
        document.body.style.overflow = '';
    }

    prev() {
        this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
        this.updateImage();
    }

    next() {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
        this.updateImage();
    }

    updateImage() {
        const currentImage = this.images[this.currentIndex];

        // Fade out
        this.lightboxImage.style.opacity = '0';

        setTimeout(() => {
            this.lightboxImage.src = currentImage.src;
            this.lightboxImage.alt = currentImage.alt;
            this.lightboxImage.style.opacity = '1';
        }, 150);

        // Update counter
        this.counter.textContent = `${this.currentIndex + 1} / ${this.images.length}`;

        // Show/hide nav buttons
        this.prevBtn.style.display = this.images.length > 1 ? 'flex' : 'none';
        this.nextBtn.style.display = this.images.length > 1 ? 'flex' : 'none';
    }
}

// Initialize lightbox
const productLightbox = new Lightbox();

// Make main product image clickable and grid gallery images open lightbox
document.addEventListener('DOMContentLoaded', () => {
    const mainImage = document.getElementById('mainImage');
    const thumbnails = document.querySelectorAll('.thumbnail');
    const gridGallery = document.querySelector('.product-gallery--thumb-grid');

    if (mainImage) {
        mainImage.style.cursor = 'pointer';
        mainImage.addEventListener('click', () => {
            const images = Array.from(thumbnails).map(thumb => ({
                src: thumb.dataset.fullSrc,
                alt: thumb.alt
            }));
            const currentIndex = Array.from(thumbnails).findIndex(t => t.classList.contains('active'));
            productLightbox.open(images, currentIndex >= 0 ? currentIndex : 0);
        });
    }

    // New product template: grid images open lightbox on click (no main-image switch)
    if (gridGallery) {
        const gridThumbnails = gridGallery.querySelectorAll('.thumbnail');
        gridThumbnails.forEach(thumb => {
            thumb.style.cursor = 'pointer';
            thumb.addEventListener('click', (e) => {
                e.preventDefault();
                const visible = Array.from(gridThumbnails).filter(t => !t.classList.contains('product-gallery-image--hidden'));
                const images = visible.map(t => ({ src: t.dataset.fullSrc, alt: t.alt }));
                const visibleIndex = visible.indexOf(thumb);
                productLightbox.open(images, visibleIndex >= 0 ? visibleIndex : 0);
            });
        });
    }
});
